module.exports = __webpack_public_path__ + "img/spq.00b202e5.png";